interface FindingsReviewGateState {
  phase: 'preparing' | 'review' | 'applied' | 'empty';
  contentReady: boolean;
}

export const shouldBlockForFindings = ({
  phase,
  contentReady,
}: FindingsReviewGateState): boolean => phase === 'preparing' && !contentReady;
